import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import Img01 from "../../images/services/da/Business-intelligence.webp";
import Img02 from "../../images/services/da/Statistical-Analysis.webp";
import Img03 from "../../images/services/da/Data-visualization.webp";
import Img04 from "../../images/services/da/Machine-learning.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Servicespartner(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Modern Needs">
                            <h2>Leveraging Big Data And Analytics To Meet Your Modern Needs</h2>
                        </div>
                        <h5 className="strong">Why choose TekRevol for big data analytics services?</h5>
                        <p>TekRevol has delivered on multiple fronts, including big data analytics. Having worked with
                            500+ small, medium, and enterprise-grade businesses, we understand the market potential for
                            ideas. We leverage this experience to serve modern-day enterprises to transform their future
                            through intelligent decision-making based on first-hand insights.</p>
                        <p> We play our part to deliver the solutions that you and your brand grow astronomically.
                            TekRevol has a dedicated team of data experts and scientists that deliver on our promise of
                            providing your business with valuable information to help you set a course for the
                            future.</p>
                         <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-lg-5 offset-lg-1">
                        <Row>
                            <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                                <div className="set_of_images hover01">
                                    <LazyLoadImage
                                        src={Img01}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Business Intelligence</p>
                                </div>
                                <div className="set_of_images hover01 mt-4">
                                    <LazyLoadImage
                                        src={Img03}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Data Visualization</p>
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-lg-4 mt-md-0">
                                <div className="set_of_images hover01">
                                    <LazyLoadImage
                                        src={Img02}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Statistical Analysis</p>
                                </div>
                                <div className="set_of_images hover01  mt-4">
                                    <LazyLoadImage
                                        src={Img04}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Machine Learning</p>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Servicespartner;